import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourMasterLight } from 'Styles/colors.css';

import WveSettingsPanelNavTab from './WveSettingsPanelNavTab/WveSettingsPanelNavTab';

const Nav = styled.ul`
  display: flex;
  list-style: none;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 0;
  border-bottom: 1px solid ${colourMasterLight};
`;

export default class WveSettingsPanelNav extends PureComponent {
  render() {
    let { topBarElements, activeTab, toggleTab } = this.props;
    if (topBarElements.length === 1 || !topBarElements.includes(activeTab)){
      activeTab = topBarElements[0];
    }
    return (
      <Nav>
        {topBarElements.map(tab =>
          <WveSettingsPanelNavTab
            key={tab}
            name={tab}
            active={tab === activeTab}
            toggleTab={toggleTab}
          />,
        )}
      </Nav>
    );
  }
}

WveSettingsPanelNav.propTypes = {
  topBarElements: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTab: PropTypes.string.isRequired,
  toggleTab: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/WveSettingsPanel/WveSettingsPanelNav/WveSettingsPanelNav.jsx